import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(({ typography, palette }) => ({
  sortIcon: {
    fontSize: typography.caption.fontSize,
    color: blueGrey[400],
    cursor: "pointer"
  },
  sortIconActive: {
    color: palette.text.primary
  }
}))
